<template>
  <div>
    <h1>401: Unauthroized</h1>
  </div>
</template>
<script>
export default {
  setup() {},
};
</script>
